import { createContext, useContext, useState } from 'react'
import { useSelector } from 'react-redux'
import Header from '../components/Header'
import Sidebar from '../containers/Sidebar'


const LayoutHeaderContext = createContext(null)

// Wird von Seiten mit scrollWithHeader als ERSTES Kind ihres Scroll-Containers
// gerendert: die Top-Leiste scrollt dann vertikal natuerlich mit weg, bleibt
// beim Horizontal-Scrollen aber links stehen (sticky left). Der overflow-hidden-
// Wrapper neutralisiert das eigene sticky-top des Headers.
export function LayoutHeaderSlot() {
  const onOpenSidebar = useContext(LayoutHeaderContext)
  if (!onOpenSidebar) return null
  return (
    <div className='sticky left-0 z-30 overflow-hidden shrink-0'>
      <Header onOpenSidebar={onOpenSidebar} />
    </div>
  )
}

// scrollWithHeader: das Layout rendert KEINE eigene Top-Leiste -- die Seite
// holt sie sich per <LayoutHeaderSlot /> in ihren eigenen Scroll-Fluss. Oben
// bleiben beim Scrollen nur sticky Elemente der Seite (Spaltennamen).
export default function Layout({ children, scrollWithHeader = false }) {
  const authCodeStatus = useSelector((state) => state.auth.status)

  const [isSidebarVisible, setIsSidebarVisible] = useState(false)
  const openSidebar = () => setIsSidebarVisible(v => !v)

  return (
    <div className='max-h-full h-full flex flex-col'>
      {!scrollWithHeader && <Header onOpenSidebar={openSidebar} />}
      <main className="overflow-hidden h-full ml-0 flex-1 flex flex-row">
        {authCodeStatus === 'authorized' && (
          <Sidebar visible={isSidebarVisible} onClose={() => setIsSidebarVisible(false)} />
        )}
        <LayoutHeaderContext.Provider value={scrollWithHeader ? openSidebar : null}>
          {children}
        </LayoutHeaderContext.Provider>
      </main>
    </div>
  )
}
